import { ValidationErrors } from '../../../../../services/WorkflowService';

/** Isolates the branchy optional-chaining lookup so call sites stay simple. */
export const getConditionError = (
  errors: ValidationErrors,
  showErrors: boolean,
  index: number,
  key: 'field' | 'operator' | 'value',
): string | undefined => (showErrors ? errors.conditions?.[index]?.[key] : undefined);

/** Isolates the branchy optional-chaining lookup so call sites stay simple. */
export const getStepConfigError = (
  errors: ValidationErrors,
  showErrors: boolean,
  index: number,
): string | undefined => (showErrors ? errors.stepErrors?.[index]?.configuration : undefined);
